export default "__VITE_ASSET__B0eb90kr__"